export default function Footer() {
  return (
    <footer>
      
      <div>
        <p className="center">&copy;{(new Date().getFullYear())} Caroline Leopold</p>
      </div>
    </footer>
  )
}